/**
 * Organizacion efectiva del usuario. La precedencia es la del payload de users/user:
 * la organizacion embebida manda, luego la franquicia, y al final el id plano.
 *
 * @param {Object|null|undefined} user
 * @returns {number|string|null}
 */
export function organizationIdOf (user) {
  if (!user) return null

  return (user.organization && user.organization.id) ||
    user.franchise_organization_id ||
    user.organization_id ||
    null
}

export function ariaDocsVisible (user, isOrganizationAdmin) {
  if (!isOrganizationAdmin || !user || !user.organization) return false

  return user.organization.total_aria_users > 0
}
